import httpClient from './httpClient'

const END_POINT = '/vehicles'

const get = qs => httpClient.get(END_POINT + qs)

export { get }
